import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
  useMutation,
} from "@tanstack/react-query";
import { Button, Form, Input, message, Radio } from "antd";
import { FC, useState } from "react";
import PhoneInputWithCountrySelect, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import { addClientCalendarModal } from "../../../../network/clients";
import { useIntl } from "react-intl";
import GenderSwitch from "../../../common/GenderSwitch";

interface AddClientFormProps {
  setClientData: React.Dispatch<any>;
  setShowClientForm: React.Dispatch<React.SetStateAction<boolean>>;
  refetch: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined
  ) => Promise<QueryObserverResult<any, unknown>>;
}

const addSVG = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="white"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 2H4.5C3.8372 2.00079 3.20178 2.26444 2.73311 2.73311C2.26444 3.20178 2.00079 3.8372 2 4.5L2 15.5C2.00079 16.1628 2.26444 16.7982 2.73311 17.2669C3.20178 17.7356 3.8372 17.9992 4.5 18H15.5C16.1628 17.9992 16.7982 17.7356 17.2669 17.2669C17.7356 16.7982 17.9992 16.1628 18 15.5V4.5C17.9992 3.8372 17.7356 3.20178 17.2669 2.73311C16.7982 2.26444 16.1628 2.00079 15.5 2ZM17 15.5C17 15.8978 16.842 16.2794 16.5607 16.5607C16.2794 16.842 15.8978 17 15.5 17H4.5C4.10218 17 3.72064 16.842 3.43934 16.5607C3.15804 16.2794 3 15.8978 3 15.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H15.5C15.8978 3 16.2794 3.15804 16.5607 3.43934C16.842 3.72064 17 4.10218 17 4.5V15.5Z"
      fill="white"
    />
    <path
      d="M10.3307 6.92285H9.66406V9.92285H6.66406V10.5895H9.66406V13.5895H10.3307V10.5895H13.3307V9.92285H10.3307V6.92285Z"
      fill="white"
    />
  </svg>
);
const AddClientForm: FC<AddClientFormProps> = ({
  // setClientId,
  setShowClientForm,
  refetch,
  setClientData,
}) => {
  const intl = useIntl();
  const [activeStaff, setActiveStaff] = useState("male");
  const addClientMutate = useMutation(addClientCalendarModal, {
    onError: (error) => {
      message.error(
        intl.formatMessage({
          id: "somethingWentWrong",
          defaultMessage: "حدث خطأ",
        })
      );
      console.log("errorr", error);
    },
    onSuccess: (res: any) => {
      if (res?.code !== "ERR_BAD_REQUEST") {
        console.log(res?.data);
        if (res?.data?.data) {
          setClientData(res?.data?.data);
        }
        message.success(
          intl.formatMessage({
            id: "clientAddedSuccessfully",
            defaultMessage: "تم اضافة العميل بنجاح",
          })
        );
        refetch();
        setShowClientForm(false);
      } else {
        message.error(res?.response?.data?.message);
      }
      return;
    },
  });
  const changeStaffGender = (e: any) => {
    setActiveStaff(e.target.value);
  };
  const handleAddClient = (values: {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    preferred_staff_gender: string;
  }) => {
    const parsedPhoneNumber = parsePhoneNumber(values?.phoneNumber || "");

    addClientMutate.mutate({
      first_name: values.firstName,
      last_name: values.lastName,
      email: values.email,
      phone: parsedPhoneNumber?.nationalNumber || "",
      phone_country_code: parsedPhoneNumber?.country || "",
      preferred_staff_gender: values.preferred_staff_gender,
    });
  };

  return (
    <div className="mt-2 p-3 bg-color-light rounded ">
      <Form
        onFinish={handleAddClient}
        layout="vertical"
        initialValues={{
          preferred_staff_gender: activeStaff,
        }}
      >
        <div className="flex justify-between gap-2 items-baseline">
          <div className="w-full">
            <Form.Item
              className="w-full"
              name={"firstName"}
              label={intl.formatMessage({
                id: "firstName",
                defaultMessage: "الاسم الأول",
              })}
              colon={false}
              required={false}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "firstNameRequired",
                    defaultMessage: "يجب إدخال الاسم الثاني",
                  }),
                },
                {
                  min: 3,
                  message: intl.formatMessage({
                    id: "nameLt3Chr",
                    defaultMessage: "الاسم  لا يقل عن 3 حروف",
                  }),
                },
              ]}
            >
              <Input className=" !border-gray-300 " />
            </Form.Item>
          </div>
          <div className="w-full">
            <Form.Item
              name={"lastName"}
              label={intl.formatMessage({
                id: "lastName",
                defaultMessage: "الاسم الثاني",
              })}
              colon={false}
              required={false}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "lastNameRequired",
                    defaultMessage: "يجب إدخال الاسم الثاني",
                  }),
                },
                {
                  min: 3,
                  message: intl.formatMessage({
                    id: "nameLt3Chr",
                    defaultMessage: "الاسم  لا يقل عن 3 حروف",
                  }),
                },
              ]}
            >
              <Input className=" !border-gray-300 " />
            </Form.Item>
          </div>
        </div>

        <div>
          <Form.Item
            name={"phoneNumber"}
            className=""
            label={intl.formatMessage({
              id: "phone",
            })}
            colon={false}
            required={false}
            hasFeedback
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "phoneRequired",
                  defaultMessage: "يجب إدخال رقم جوال العميل",
                }),
              },

              {
                validator: (_, value) => {
                  if (value && !isValidPhoneNumber(value)) {
                    return Promise.reject(
                      new Error(
                        intl.formatMessage({
                          id: "invalidPhoneNumber",
                          defaultMessage: "رقم جوال غير صحيح",
                        })
                      )
                    );
                  } else {
                    return Promise.resolve();
                  }
                },
              },
            ]}
          >
            <PhoneInputWithCountrySelect
              defaultCountry="SA"
              international
              style={{}}
              className="bg-white "
              onChange={() => {}}
              limitMaxLength={true}
            />
          </Form.Item>
        </div>
        <div>
          <Form.Item
            label={intl.formatMessage({
              id: "email",
              defaultMessage: "البريد الألكتروني",
            })}
            name={"email"}
            colon={false}
            required={false}
            hasFeedback
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "emailRequired",
                  defaultMessage: "يجب إدخال بريد العميل ",
                }),
              },
              {
                type: "email",
                message: intl.formatMessage({
                  id: "invalidEmail",
                  defaultMessage: "البريد الالكتروني غير صحيح",
                }),
              },
            ]}
          >
            <Input className=" !border-gray-300 " />
          </Form.Item>
        </div>
        <div className="py-2">
          <Form.Item
            name="preferred_staff_gender"
            required={false}
            className="col-span-2 w-full  !-mt-6"
          >
            <div className="p-2 bg-white rounded flex max-lg:grid items-center justify-between col-span-2">
              <div className="max-lg:mb-3">
                {intl.formatMessage({
                  id: "iWouldLikeToDealWith",
                })}
                :
              </div>
              <Radio.Group onChange={changeStaffGender}>
                <div className="flex gap-2 justify-between">
                  <GenderSwitch
                    active={"male" === activeStaff}
                    gender="male"
                    string={intl.formatMessage({
                      id: "man",
                    })}
                  />
                  <GenderSwitch
                    active={"female" === activeStaff}
                    gender="female"
                    string={intl.formatMessage({
                      id: "woman",
                    })}
                  />
                </div>
              </Radio.Group>
            </div>
          </Form.Item>
        </div>
        <div className=" flex gap-1 w-full">
          <Button type="primary" htmlType="submit" block>
            <div className="flex gap-1 items-center justify-center ">
              <span>
                {intl.formatMessage({
                  id: "Add",
                  defaultMessage: "أضف",
                })}
              </span>
              <span className="mt-1">{addSVG}</span>
            </div>
          </Button>
          <Button
            type="default"
            htmlType="button"
            block
            onClick={() => {
              setShowClientForm(false);
            }}
          >
            {intl.formatMessage({
              id: "cancel",
              defaultMessage: "إالغاء",
            })}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default AddClientForm;
